import React, { Component } from 'react'
import BodyClassName from 'react-body-classname'
import {
  Link
} from 'react-router-dom'
import Icon from '../buttons/Icon'
import { withRouter } from 'react-router'
import CONSTANTS from '../../constants.js'

import image404AP from '../../images/AP/ap-404.jpg'
import image404AC from '../../images/AC/AC_Alert.svg'
import image404DS from '../../images/DS/ds-404.png'
import image404OV from '../../images/OV/ov-404.png'

class NotFoundPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    const image404 = (window.siteConfig.currentBrand == 'P' ? image404AP : (window.siteConfig.currentBrand == 'C' ? image404AC : (window.siteConfig.currentBrand == 'D' ? image404DS : image404OV)))
    return (
      <div>
        <BodyClassName className='withSummary page--Erorr' />
        <div className='error-content container-medium-content'>
          {/* <Icon Name='error-404' /> */}
          <h2 tabIndex="0" className='title' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.common_v2_errorpage_title) }}></h2>
          <p className='error-content__image'>
            <img src={image404} width={window.siteConfig.currentBrand === 'C' && window.isMobile() === "desktop" ? "192" : window.siteConfig.currentBrand === 'C' && window.isMobile() === "mobile" ? "96" : undefined} />
          </p>

          <p tabIndex="0" className='text' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.common_v2_errorpage_description) }}></p>

          <Link
            className='error-button'
            to={`${CONSTANTS.SITE_ROUTS.HOMEPAGE}`}
          >
            {CONSTANTS.LABELS.common_v2_errorpage_button}
          </Link>
        </div>
      </div>
    )
  }
}

export default withRouter(NotFoundPage)
